export default __webpack_public_path__ + "2a99634f50937fbd07af93de69a66989.png";